export type SerializablePattern = string | RegExp | { value: string; flags?: string };

/**
 * Convert HTML pattern to RegExp from string as a unicode sequence.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/pattern#overview
 * @internal
 */
export function normalizePattern(
  pattern?: SerializablePattern,
  defaultFlags = 'v',
): RegExp | undefined {
  if (!pattern) {
    return;
  }

  if (pattern instanceof RegExp) {
    return pattern;
  }

  if (typeof pattern === 'string') {
    return new RegExp(pattern, defaultFlags);
  }

  return new RegExp(pattern.value, pattern.flags ?? defaultFlags);
}
